<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px">
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="供应商编号" prop="supplierCode">
                <el-input class="handle-input" v-model="queryCondition.supplierCode" clearable></el-input>
                <el-input v-model="queryCondition.type" v-show="false"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="供应商名称" prop="supplierName">
                <el-input class="handle-input" v-model="queryCondition.supplierName" clearable></el-input>
              </el-form-item>

            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.common.status')">
                <el-select v-model="queryCondition.status" class="handle-input" :disabled="true">
                  <el-option :label="$t('common.all')" value=""></el-option>
                  <el-option :key="index" v-for="(item,index) in supplierStatusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row type="flex" justify="center">
            <el-button class="btn" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button type="primary" @click="clickSelectMethod">{{$t('common.select')}}</el-button>
      </el-row>
      <el-table :data="tableData" border highlight-current-row class="table" :row-key="getRowKeys" @selection-change="handleSelectionChange" ref="supplierSelectTabel">
        <el-table-column v-if="multipleSelectionFlag" sortable prop="tmSupplierId" type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
        <el-table-column align="center" v-else width="55">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getTemplateRow(scope.row)" :label="scope.row.tmSupplierId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="supplierCode" align="center" label="供应商编号"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="supplierName" align="center" label="供应商名称"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="city" align="center" label="供应商所在城市"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="emailAddress" align="center" :label="$t('base.common.emailAddress')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="statusI18n" align="center" :label="$t('base.common.status')"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { selPageSearch } from "../../../api/base-data/supplier";
import { inputChoiceService } from "../../../api/common/input-choice";
import commonFunction from "../../../utils/dataTableUtils"
export default {
  name: 'supplier-sel-page',
  props: {
    multipleSelectionFlag: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
    }
  },
  data() {
    return {
      tableData: [],
      totalCount: 0,
      labelPosition: 'right',
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        status: '1',
        supplierCode: '',
        supplierName: '',
        type: 'SUPPLIER',
      },
      multipleSelection: [],
      supplierStatusList: [],
      getRowKeys(row) {
        return row.tmSupplierId;
      },
      selectRows: [],
      radioVal: null,
    }
  },
  created() {
    this.queryData(1);
    this.getInputChoiceValues();
  },
  watch: {
    visible() {
      this.$refs.supplierSelectTabel.clearSelection();
    }
  },
  methods: {
    //查询承运商
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      selPageSearch(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      })
    },
    clickSelectMethod: function () {
      if (this.selectRows.length == 0) {
        this.$message({ message: "请选供应商", type: "warning" });
      } else {
        this.$emit('subCallMethod', this.selectRows);
      }
    },
    //获取下拉列表数据
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["COMMON:STATUS_DISABLE_ENABLE"] = "COMMON:STATUS_DISABLE_ENABLE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.supplierStatusList = res["COMMON:STATUS_DISABLE_ENABLE"];
      });
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows;
      this.selectRows = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.selectRows.push(row);
          }
        });
      }
    },
    //单选操作
    getTemplateRow(row) {
      this.selectRows = [];
      this.selectRows.push(row);
    },
  },
  extends: commonFunction
}
</script>
<style scoped>
.handle-input {
  width: 95%;
}
.query-btn-row {
  width: 30%;
  float: right;
}
.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}
.dialog-input {
  width: 40%;
}
</style>
